<template>
  <div class="content">
    <div class="btn-group">
      <button class="btn btn-sm btn-warning" @click="editarIteracion">
        Editar
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "EditarTicketTableActions",
  methods: {
    async editarIteracion() {
      const iteracion = this.params.data;

      this.$store.commit(
        "Suspensiones/EvitarSuspensiones/setIteracionAEditar",
        iteracion,
      );

      this.$bvModal.show("editarIteracion");
    },
  },
});
</script>
